import React, { useState } from "react";
import { TextField, Popover, Grid, Button, Box } from "@mui/material";

const DayPickerInput = ({ selectedDate, onDateSelect,formErrors }) => {
    const [anchorEl, setAnchorEl] = useState(null);
    const handleInputClick = (event) => {
        setAnchorEl(event.currentTarget);
    };

    const handleDayClick = (day) => {
        onDateSelect(day); // Send selected day to the parent component
        setAnchorEl(null); // Close the Popover after selection
    };

    const handleClose = () => {
        setAnchorEl(null); // Close the Popover
    };

    const open = Boolean(anchorEl);
    const id = open ? "day-picker-popover" : undefined;

    return (
        <Box>
            <TextField
                required
                label="Select Day For Payment"
                value={selectedDate ? selectedDate : ""}
                onClick={handleInputClick}
                fullWidth
                readOnly

                error={!!formErrors?.SelectDate}
                helperText={formErrors?.SelectDate}
            />
            <Popover
                id={id}
                open={open}
                anchorEl={anchorEl}
                onClose={handleClose}
                anchorOrigin={{
                    vertical: 'center',
                    horizontal: 'center',
                }}
                transformOrigin={{
                    vertical: 'center',
                    horizontal: 'center',
                }}
            >
                <Grid container spacing={1} style={{ padding: 10, maxWidth: 300 }}>
                    {Array.from({ length: 28 }, (_, i) => i + 1).map((day) => (
                        <Grid item xs={3} key={day}>
                            <Button
                                variant={selectedDate === day ? "contained" : "outlined"}
                                color="primary"
                                fullWidth
                                onClick={() => handleDayClick(day)}
                            >
                                {day}
                            </Button>
                        </Grid>
                    ))}
                </Grid>
            </Popover>
        </Box>
    );
};

export default DayPickerInput;


// import React, { useState } from "react";
// import { TextField, Popover, Grid, Button, Box } from "@mui/material";

// const DayPickerInput = ({selectedDate, onDateSelect }) => {
//     const [anchorEl, setAnchorEl] = useState(null);
//     const [selectedDay, setSelectedDay] = useState("");
//     // console.log("selectedDay: ", selectedDay);

//     const handleInputClick = (event) => {
//         setAnchorEl(event.currentTarget);
//     };

//     const handleDayClick = (day) => {
//         setSelectedDay(day);
//         setAnchorEl(null); // Close the Popover after selection
//         onDateSelect(day); // Send selected day to the parent component
//     };

//     const handleClose = () => {
//         setAnchorEl(null); // Close the Popover
//     };

//     const open = Boolean(anchorEl);
//     const id = open ? "day-picker-popover" : undefined;

//     return (
//         <Box>
//             <TextField
//                 label="Select Day For Payment"
//                 value={selectedDay ? selectedDay : ""}
//                 onClick={handleInputClick}
//                 fullWidth
//                 readOnly
//             />
//             <Popover
//                 id={id}
//                 open={open}
//                 anchorEl={anchorEl}
//                 onClose={handleClose}
//                 anchorOrigin={{
//                     vertical: 'center',
//                     horizontal: 'center',
//                 }}
//                 transformOrigin={{
//                     vertical: 'center',
//                     horizontal: 'center',
//                 }}
//             >
//                 <Grid container spacing={1} style={{ padding: 10, maxWidth: 300 }}>
//                     {Array.from({ length: 28 }, (_, i) => i + 1).map((day) => (
//                         <Grid item xs={3} key={day}>
//                             <Button
//                                 variant={selectedDay === day ? "contained" : "outlined"}
//                                 color="primary"
//                                 fullWidth
//                                 onClick={() => handleDayClick(day)}
//                             >
//                                 {day}
//                             </Button>
//                         </Grid>
//                     ))}
//                 </Grid>
//             </Popover>
//         </Box>
//     );
// };

// export default DayPickerInput;

